import { headers } from "./ApiHelpers";

const baseUrl = "/api/purge";

export const purgeSyncData = async (syncId: string, deviceId: string): Promise<void> => {
  const url = `${baseUrl}?device_id=${deviceId}`;

  const raw = await fetch(url, {
    method: "DELETE",
    headers: headers(),
    body: JSON.stringify({ SyncID: syncId }),
  });

  if (raw.status !== 204 && raw.status !== 200) {
    const errorResponse: unknown = await raw.json();
    if (errorResponse !== null && typeof errorResponse === "object" && "error" in errorResponse) {
      throw new Error(String(errorResponse.error));
    }
    throw new Error("Invalid response from server");
  }
};
